import { CompanyQuery, gqlCompany } from "../generated/graphql";
import { useGraphqlQuery } from "./graphql";

export function useGetCompany(slug: string) {
  const { requestState } = useGraphqlQuery<CompanyQuery>(gqlCompany, {
    variables: { slug },
  });
  return requestState;
}
